import {useEffect} from "react"
import {Link} from "react-router-dom"
import {default as cx} from "classnames"

import SubHeader from "../SubHeader.jsx"

function MetricsHome() {
    useEffect(() => {
        document.title = "Metrics & Scores"
    }, [])

    return (
        <>
            <SubHeader title1="OARS" title2="Metrics & Scores" icon="fa-clipboard-list" />
            <div className="container">
                <div className="py-10">
                    <h2 className="text-center mb-8">Please make a selection below</h2>
                    <div className="row g-0 g-xl-8">
                        <div className="col-xl-6 mb-5 mb-lg-0">
                            <Link
                                to="/metrics/dashboard"
                                className="card bg-light flex-center p-6 card-bordered border-hover-primary"
                            >
                                <div className="card-header border-0 mb-3">
                                    <div className="card-title">
                                        <i className={cx("fas text-primary fs-3x", "fa-chart-simple")}></i>
                                    </div>
                                </div>
                                <div className="card-body py-2 py-lg-0">
                                    <div className="text-gray-900 fw-bold fs-2 text-center">
                                        Metrics Dashboard
                                        <span className="fs-6 fw-semibold d-flex flex-column pt-2">
                                            Overview, compliance, performance, financial, and demographic metrics.
                                        </span>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default MetricsHome
